import { Link } from "react-router-dom";
import { SuccesSVG } from "../../assets";

function NavigateEmailSuccessPage() {
  return (
    <div className="w-full h-full flex items-center flex-col  justify-center">
      <div
        style={{
          height: 332,
          width: 332,
        }}
        className="rounded-lg p-6 mt-8 flex flex-col items-center justify-center"
      >
        <img className="cursor-pointer" src={SuccesSVG} alt="SuccesSVG-icon" />
      </div>
      <div className="mt-8 text-xl font-semibold">
        Password reset link sent successfully.{" "}
      </div>
      <div className="text-gray-500">
        Please check your email to reset your password..{" "}
      </div>
      {/* <Link className="mt-2 text-[blue] underline" to={"/login"}>
        Back To Login
      </Link> */}
    </div>
  );
}

export default NavigateEmailSuccessPage;
